import dayjs from "dayjs";
import { getOrdersByEmail, getLDSOrders } from "../../services/fhpService";
import { getDynamicOrders } from "../../services/dynamicService";
import { getUserInfo } from "../../services/localStorage";
import { orderDateRangeToFlatApiPayload } from "../orders/filters";

/**
 * אותו מקור נתונים כמו `loadAllOrdersForTableView` ב־Orders.jsx (טאב טבלה / צפייה מאוחדת).
 * לא משנה את לוגיקת ההזמנות — רק משכפל את קריאות ה־API והפילטר התאריכי למלונות.
 *
 * @param {object} ldsOrdersGuardCtx — אובייקט ההרשאות כמו ב־Orders (useAgentEntitlements)
 * @param {[import("dayjs").Dayjs, import("dayjs").Dayjs] | null} dateRange — טווח יצירה; ברירת מחדל 6 חודשים
 * @returns {Promise<{ hotels: any[], packages: any[], flights: any[], organizedTours: any[], dynamicPackages: any[] }>}
 */
export async function fetchAgentOrdersBundleForOperationRequest(
  ldsOrdersGuardCtx,
  dateRange = null,
  options = {}
) {
  const empty = {
    hotels: [],
    packages: [],
    flights: [],
    organizedTours: [],
    dynamicPackages: [],
  };

  const userInfo = getUserInfo();
  if (!userInfo?.id && !userInfo?.email) {
    return empty;
  }

  const monthsBack =
    typeof options.monthsBack === "number" && options.monthsBack > 0
      ? options.monthsBack
      : options.forSearch === true
        ? 36
        : 6;
  const rangeStart = dayjs().subtract(monthsBack, "months");
  const today = dayjs();
  const startDate = dateRange?.[0] || rangeStart;
  const endDate = dateRange?.[1] || today;

  const startDateStr = startDate.format("DD/MM/YYYY");
  const endDateStr = endDate.format("DD/MM/YYYY");
  /** פנייה לאופרציה: כולל מבוטלות (ביטול, זיכוי, בירור). */
  const ldsOrderDateFilter = {
    order_dates: { start: startDateStr, end: endDateStr },
    include_cancelled: true,
    op_request_search: true,
  };
  const dynamicDateFilter = {
    ...orderDateRangeToFlatApiPayload(startDate, endDate),
    include_cancelled: true,
    op_request_search: true,
  };
  const hotelsPayload = {
    email: userInfo.email,
    include_cancelled: true,
    op_request_search: true,
  };

  console.log("[OP_REQUEST_SEARCH_API_PAYLOAD]", {
    endpoint: "getOrders",
    payload: hotelsPayload,
    dateRange: { start: startDateStr, end: endDateStr, monthsBack },
  });
  console.log("[OP_REQUEST_SEARCH_API_PAYLOAD]", {
    endpoint: "getLDSOrdersByAgentId",
    payload: { deal_types: ["FlightsHotel", "Flights", "OrganizedTour"], ...ldsOrderDateFilter },
    dateRange: { start: startDateStr, end: endDateStr, monthsBack },
  });
  console.log("[OP_REQUEST_SEARCH_API_PAYLOAD]", {
    endpoint: "getDynamicOrders",
    payload: { agent_id: userInfo.id, page: 1, size: 1000, ...dynamicDateFilter },
  });

  const [hotelsData, packagesData, flightsData, organizedToursData, dynamicPackagesData] =
    await Promise.all([
      userInfo?.email
        ? getOrdersByEmail(hotelsPayload).catch(() => ({
            data: { orders: [] },
          }))
        : Promise.resolve({ data: { orders: [] } }),
      userInfo?.id
        ? getLDSOrders(userInfo.id, "FlightsHotel", 1, 1000, ldsOrderDateFilter, ldsOrdersGuardCtx).catch(
            () => ({ data: { orders: [] } })
          )
        : Promise.resolve({ data: { orders: [] } }),
      userInfo?.id
        ? getLDSOrders(userInfo.id, "Flights", 1, 1000, ldsOrderDateFilter, ldsOrdersGuardCtx).catch(
            () => ({ data: { orders: [] } })
          )
        : Promise.resolve({ data: { orders: [] } }),
      userInfo?.id
        ? getLDSOrders(userInfo.id, "OrganizedTour", 1, 1000, ldsOrderDateFilter, ldsOrdersGuardCtx).catch(
            () => ({ data: { orders: [] } })
          )
        : Promise.resolve({ data: { orders: [] } }),
      userInfo?.id
        ? getDynamicOrders(
            { agent_id: userInfo.id, page: 1, size: 1000, ...dynamicDateFilter },
            ldsOrdersGuardCtx
          ).catch(() => ({ data: { orders: [] } }))
        : Promise.resolve({ data: { orders: [] } }),
    ]);

  let hotelsOrders = hotelsData?.data?.orders || [];
  if (hotelsOrders.length > 0) {
    hotelsOrders = hotelsOrders.filter((order) => {
      if (!order.creationdate) {
        return true;
      }
      try {
        const orderDate = dayjs(order.creationdate, "DD/MM/YYYY");
        return orderDate.isAfter(startDate.subtract(1, "day")) && orderDate.isBefore(endDate.add(1, "day"));
      } catch {
        return true;
      }
    });
  }

  return {
    hotels: hotelsOrders,
    packages: packagesData?.data?.orders || [],
    flights: flightsData?.data?.orders || [],
    organizedTours: organizedToursData?.data?.orders || [],
    dynamicPackages: dynamicPackagesData?.data?.orders || [],
  };
}
